import React, { useMemo } from 'react';
import {
  Badge, Box, Typography,
} from '@mui/material';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import { getGabbaiTheme } from '../gabbaiPortalTheme';
import PortalSearchSelect from '../PortalSearchSelect';

const TILES = [
  { key: 'members', label: 'רשימת החברים', icon: GroupsOutlinedIcon },
  { key: 'orders', label: 'הזמנות מבחנים', icon: Inventory2OutlinedIcon },
  { key: 'messages', label: 'הודעות מהמערכת', icon: MailOutlineIcon },
  { key: 'dates', label: 'זמני מבחנים', icon: EventOutlinedIcon },
];

export default function HomeScreen({
  gabaiName,
  kolels,
  activeKolelId,
  onKolelChange,
  messagesCount,
  onNavigate,
}) {
  const t = getGabbaiTheme();
  const activeKolel = kolels.find((k) => k.id === activeKolelId);
  const kolelOptions = useMemo(
    () => (kolels || []).map((k) => ({ id: k.id, label: k.name })),
    [kolels]
  );

  return (
    <Box sx={{ maxWidth: 560, mx: 'auto' }}>
      <Typography
        sx={{
          color: '#f5f0e6',
          fontFamily: '"Frank Ruhl Libre", "David Libre", serif',
          fontWeight: 700,
          fontSize: { xs: '1.45rem', sm: '1.7rem' },
          textAlign: 'center',
          mb: 0.5,
        }}
      >
        שלום{gabaiName ? `, ${gabaiName}` : ''}
      </Typography>
      <Typography sx={{ color: 'rgba(245,240,230,0.72)', textAlign: 'center', mb: 3 }}>
        {activeKolel ? `כולל ${activeKolel.name}` : 'אזור אישי לגבאים'}
      </Typography>

      {kolels.length > 1 && (
        <PortalSearchSelect
          label="כולל פעיל"
          options={kolelOptions}
          value={activeKolelId || ''}
          onChange={onKolelChange}
          placeholder="חיפוש כולל..."
          sx={{ mb: 3 }}
        />
      )}

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2,
        }}
      >
        {TILES.map((tile) => {
          const Icon = tile.icon;
          const tileButton = (
            <Box
              component="button"
              type="button"
              onClick={() => onNavigate(tile.key)}
              sx={{
                appearance: 'none',
                width: '100%',
                border: `1px solid ${t.cardBorder}`,
                background: t.cardBg,
                borderRadius: 3,
                minHeight: 120,
                px: 2.5,
                py: 2.5,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 2,
                textAlign: 'right',
                color: '#f5f0e6',
                transition: 'transform 0.15s ease, border-color 0.15s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  borderColor: t.accentSoft,
                },
                '&:active': { transform: 'translateY(0)' },
              }}
            >
              <Icon sx={{ fontSize: 32, color: t.accent }} />
              <Typography sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                {tile.label}
              </Typography>
            </Box>
          );

          if (tile.key === 'messages' && messagesCount > 0) {
            return (
              <Badge
                key={tile.key}
                badgeContent={messagesCount}
                color="error"
                sx={{
                  '& .MuiBadge-badge': { top: 12, left: 12, right: 'auto' },
                  display: 'block',
                  width: '100%',
                }}
              >
                {tileButton}
              </Badge>
            );
          }
          return <Box key={tile.key}>{tileButton}</Box>;
        })}
      </Box>
    </Box>
  );
}
